var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_417_1081)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 10C0.5 4.4775 4.9775 0 10.5 0C16.0225 0 20.5 4.4775 20.5 10C20.5 15.5225 16.0225 20 10.5 20C4.9775 20 0.5 15.5225 0.5 10ZM11.625 12.0019H9.48895V11.8609C9.49987 9.89532 9.98061 9.60745 10.8629 9.0791C10.9561 9.02327 11.0539 8.96475 11.156 8.90128C11.8865 8.44247 12.4479 7.86292 12.4479 7.01775C12.4479 6.06996 11.7054 5.45419 10.7817 5.45419C9.9305 5.45419 9.12467 5.85206 9.07034 6.987H6.80371C6.86408 4.69296 8.68086 3.5 10.7938 3.5C13.0999 3.5 14.6876 4.94709 14.6876 6.98757C14.6876 8.37003 13.9934 9.27557 12.8826 9.93963C12.798 9.99152 12.7187 10.0392 12.6445 10.0839C11.8554 10.559 11.6361 10.6911 11.625 11.8609V12.0019ZM11.7958 15.014C11.7897 15.7505 11.18 16.3421 10.4677 16.3421C9.73115 16.3421 9.13349 15.7505 9.13953 15.014C9.13349 14.2896 9.73115 13.698 10.4677 13.698C11.18 13.698 11.7897 14.2896 11.7958 15.014Z",
    fill: "#5C5F62"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_1081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.51295aae48e5b2b27d5927256e8a9bf2.svg";
export { ForwardRef as ReactComponent };